import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-check-button',
  templateUrl: './check-button.component.html',
  styleUrls: ['./check-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CheckButtonComponent {
  @Input() public checked = false;
  @Input() public title = '';
  @Input() public info = '';
  @Input() public reverse = false;
  @Input() public smallFont = false;
}
